import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function About() {
    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-6 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
                    About ClickBoard
                </h1>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark rounded-[28px] border border-borderLight dark:border-borderDark p-8 md:p-10">

                    {/* INTRO */}
                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        ClickBoard is a fast, simple, and secure online clipboard tool designed to help users instantly transfer text between devices without any login, installation, or complicated setup. Whether you are using a laptop, smartphone, or tablet, ClickBoard allows you to move text across devices in seconds using a simple code-based system.
                    </p>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        In today’s digital world, people frequently switch between multiple devices throughout the day. However, transferring text between these devices is often inconvenient. Many users rely on email, messaging apps, or cloud tools, which can be slow, distracting, or require multiple steps. ClickBoard was created to solve this problem by providing a faster and more efficient solution.
                    </p>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        With ClickBoard, you can simply paste your text, generate a unique code, and retrieve that text from any other device instantly. The entire process takes just a few seconds and works on all modern browsers without requiring any technical knowledge.
                    </p>

                    {/* WHY */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Why ClickBoard Exists
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We built{" "}
                        <Link to="/" className="text-primary hover:underline">
                            ClickBoard
                        </Link>{" "}
                        to remove unnecessary complexity from everyday digital tasks. Existing methods like emailing yourself or using messaging apps are not designed specifically for quick text transfer. Our goal was to create a lightweight tool that is fast, simple, and accessible to everyone.
                    </p>

                    {/* FEATURES */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        What Makes ClickBoard Different
                    </h2>

                    <ul className="list-disc ml-6 text-textMain dark:text-textDark space-y-2 mb-6">
                        <li>No login or account required</li>
                        <li>No app installation needed</li>
                        <li>Works on all devices and browsers</li>
                        <li>Instant text transfer using a unique code</li>
                        <li>Clean and easy-to-use interface</li>
                        <li>Completely free to use</li>
                    </ul>

                    {/* SECURITY */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Security and Privacy
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We understand that privacy is important. ClickBoard uses a secure code-based system where only users with the correct code can access the stored text. Your data is temporary and designed to be removed after use, ensuring that it is not permanently stored or publicly accessible.
                    </p>

                    {/* USERS */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Who Uses ClickBoard
                    </h2>

                    <ul className="list-disc ml-6 text-textMain dark:text-textDark space-y-2 mb-6">
                        <li>Students transferring notes between devices</li>
                        <li>Developers sharing code snippets</li>
                        <li>Professionals sending quick links</li>
                        <li>Anyone who needs fast and simple text transfer</li>
                    </ul>

                    {/* MISSION */}
                    <h2 className="text-2xl font-semibold text-titleLight dark:text-titleDark mt-8 mb-4">
                        Our Mission
                    </h2>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Our mission is to simplify digital workflows by removing unnecessary steps and making everyday tasks faster and easier. We believe that sharing information between devices should be simple, secure, and accessible to everyone.
                    </p>

                    {/* FUTURE */}
                    <p className="text-textMain dark:text-textDark leading-8">
                        We are continuously working on improving ClickBoard by enhancing performance and adding useful features. Our goal is to make it one of the most reliable and user-friendly tools for everyday digital use.
                    </p>

                </div>

                <Footer />

            </div>

        </section>
    );
}